import { render, staticRenderFns } from "./DashboardAnalisys.vue?vue&type=template&id=f3d900ca&scoped=true&"
import script from "./DashboardAnalisys.vue?vue&type=script&lang=js&"
export * from "./DashboardAnalisys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d900ca",
  null
  
)

export default component.exports